import { Icon } from "../../../../components";
import { useIsMobile } from "../../../hooks/useIsMobile";
import css from "./NotificationComponent.module.scss";

interface NotificationCashoutProps {
  payout: string;
  multiplayer: string;
}

const MobileComponent = ({ payout, multiplayer }: NotificationCashoutProps) => (
  <div className={css.mobileSuccessNotif}>
    <Icon className={css.startsIcon} width={22} height={20} name="stars" />
    <div className={css.mobileHeaderNotif}>
      <div className={css.mobileTextContainer}>
        <span>WIN</span>
        <span>{payout}</span>
      </div>
    </div>
    <div className={css.mobileFooterNofit}>
      <span>YOU HAVE CASHED OUT</span>
      <span>{multiplayer}x</span>
    </div>
  </div>
);

const DesktopComponent = ({
  payout,
  multiplayer,
}: NotificationCashoutProps) => (
  <div className={css.successNotif}>
    <div className={css.headerNotif}>
      <Icon width={24} height={24} name="star-left" />
      <div className={css.textContainer}>
        <span>WIN</span>
        <span>{payout}</span>
      </div>
      <Icon width={24} height={24} name="star-right" />
    </div>
    <div className={css.footerNofit}>
      <span>YOU HAVE CASHED OUT</span>
      <span>{multiplayer}x</span>
    </div>
  </div>
);

const NotificationCashout = ({
  payout,
  multiplayer,
}: NotificationCashoutProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileComponent payout={payout} multiplayer={multiplayer} />;
  }

  return <DesktopComponent payout={payout} multiplayer={multiplayer} />;
};

export default NotificationCashout;
